import { render, staticRenderFns } from "./GdprModal.vue?vue&type=template&id=343bb424"
import script from "./GdprModal.vue?vue&type=script&lang=js"
export * from "./GdprModal.vue?vue&type=script&lang=js"
import style0 from "./GdprModal.vue?vue&type=style&index=0&id=343bb424&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports